import React from 'react';
import { useState, useEffect, useRef } from 'react';
import bluedownarrow from '../../images/common/bluedownarrow.png'
import blueuparrow from '../../images/common/blueuparrow.png'
import '../../scss/reusables/dropdown.scss'

function ClickOutside(ref, setDropdownCliked) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function CityStatedropdown({selectedItem, label, list, handleLabel}) {
    const dropdownwrapperRef = useRef(null);
    const [isDropdownCliked, setDropdownCliked] = useState(false);
    ClickOutside(dropdownwrapperRef, setDropdownCliked);
    const [callingCodeSuggestions, setCallingCodeSuggestions] = useState([]);

    const getState = (value) => {
        selectedItem(value);
        handleLabel(value);

        let suggestions = [];
        if(value != "") {
            list.length > 0 && list.map((item) => {
                if(item.toLowerCase().includes(value.toLowerCase())) {
                    suggestions.push(item)
                }
            })
        }
        setCallingCodeSuggestions(suggestions);
        setDropdownCliked(true);
    }

    const getStateFromSelection = (value) => {
        selectedItem(value);
        handleLabel(value);
        setDropdownCliked(false);
    }
    
    return (
        <div className='dropdown' ref={dropdownwrapperRef}>
            <div className='state-dropdown-container'>
                <input className='state-dropdown' value={label} onChange={(e) => getState(e.target.value)} maxLength={45}/>
            </div>
            {isDropdownCliked && (
                <div className='dropdown-list'>
                    {callingCodeSuggestions.length > 0 && callingCodeSuggestions.map((item, index) => {
                        return (
                            <>
                                <div className='dropdown-content-inner' onClick={(e) => getStateFromSelection(item)}>{item}</div>
                            </>
                        )
                    })}
                </div>
            )}
        </div>
    );
}

export default CityStatedropdown;

